import clsx from "clsx";
import { WorkspaceDropdown } from "react-migration/domains/workspaces/components/WorkspaceDropdown";
import { ActiveNavTabProvider } from "react-migration/layouts/nav/ActiveNavTabContext";
import { LeftHandSideExpandTrayMobile } from "react-migration/layouts/map/Multilayer/Bundle/LeftHandSideExpandTrayMobile";
import { GlobalSearch } from "react-migration/components/GlobalSearch";
import { setGlobalSearchMapPinFromCallback } from "src/js/stores/map/actions/updateSearch";
import { useSnapshot } from "valtio";
import { mapStore } from "src/js/stores/map/store";
import { useIsMobile } from "react-migration/lib/theme/hooks/useIsMobile";

// Could later be changed to use useActiveNavTab() and drop the activeRoute prop.
export const WorkspaceHeader = ({ activeRoute }: { activeRoute: string }) => {
  const withSearch = activeRoute === "map" || activeRoute === "search";
  const { settings } = useSnapshot(mapStore);
  const isMobile = useIsMobile();

  if (!isMobile || !["map", "search", "sites", "lettersBatches", "sharedSites"].includes(activeRoute)) {
    return null;
  }

  const pathname = activeRoute.startsWith("/") ? activeRoute : `/${activeRoute}`;

  return (
    <ActiveNavTabProvider pathname={pathname}>
      <div
        className={clsx(
          "flex flex-col top-0 right-0 z-99 w-dvw bg-background-surface",
          settings.streetView && "hidden"
        )}
      >
        <WorkspaceDropdown />
        {withSearch && (
          <div className="h-12 w-full flex flex-row no-wrap gap-4 items-start px-4">
            <LeftHandSideExpandTrayMobile className="relative sm:flex! shadow-none! top-0! left-0! p-2.5! h-11!" />
            <GlobalSearch
              className={clsx("relative")}
              inputClassName={clsx("w-full h-11! relative! shadow-none!")}
              onSearchLocationChange={setGlobalSearchMapPinFromCallback}
            />
          </div>
        )}
      </div>
    </ActiveNavTabProvider>
  );
};
